import { render, staticRenderFns } from "./DisplayInfo.vue?vue&type=template&id=37f2d6f2&scoped=true&"
import script from "./DisplayInfo.vue?vue&type=script&lang=js&"
export * from "./DisplayInfo.vue?vue&type=script&lang=js&"
import style0 from "./DisplayInfo.vue?vue&type=style&index=0&id=37f2d6f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f2d6f2",
  null
  
)

export default component.exports